import React, { Component } from 'react';
import Linkify from 'react-linkify';
import { localize } from 'react-localize-redux';
import { getTranslatedString } from 'helpers/i18n';

const styles = {
  seenBy: {
    fontSize: '9px',
    margin: '3px 0 0',
    fontFamily: 'Circular',
  },
};

class TextMessage extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="sc-message--text">
          <Linkify properties={{ target: '_blank' }}>{this.props.data.text}</Linkify>
        </div>
        <p style={styles.seenBy}>{this.props.data.author}</p>
        {this.renderTime(this.props.data.date, this.props.data.time)}
      </React.Fragment>
    );
  }

  renderTime = (date, time) => {
    if (!date) return;
    if (!time) return;

    return (
      <p style={styles.seenBy}>
        {getTranslatedString('portal.messagingSentOn', { date: date, time: time })}
      </p>
    );
  };
}

export default localize()(TextMessage);
